import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const InfoIcon = ({circleColor, ...props}) => {
    return (
        <Icon viewBox="0 0 40 40" data-testid="info-icon" {...props}>
            {/* {isBackgroundRectangular ? (
                <rect width="40" height="40" rx="3" stroke="transparent" />
            ) : (
                <circle cx="20" cy="20" r="20" />
            )}
            <path
                id="Combined-Shape"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.1891 15.237C20.7651 15.237 21.2325 15.7044 21.2325 16.2804V29.8457H24.363C24.939 29.8457 25.4065 30.3131 25.4065 30.8891C25.4065 31.4651 24.939 31.9326 24.363 31.9326H16.0152C15.4392 31.9326 14.9717 31.4651 14.9717 30.8891C14.9717 30.3131 15.4392 29.8457 16.0152 29.8457H19.1456V17.3239H16.0152C15.4392 17.3239 14.9717 16.8564 14.9717 16.2804C14.9717 15.7044 15.4392 15.237 16.0152 15.237H20.1891ZM20.1891 7.93262C21.3411 7.93262 22.276 8.86549 22.276 10.0196C22.276 11.1716 21.3411 12.1065 20.1891 12.1065C19.0371 12.1065 18.1021 11.1716 18.1021 10.0196C18.1021 8.86549 19.0371 7.93262 20.1891 7.93262Z"
                fill="currentColor"
            /> */}
            <path
                d="M20 1C9.52178 1 1 9.52178 1 20C1 30.4782 9.52178 39 20 39C30.4782 39 39 30.4782 39 20C39 9.52178 30.4782 1 20 1ZM20 37.1188C10.5564 37.1188 2.88119 29.4436 2.88119 20C2.88119 10.5564 10.5658 2.88119 20 2.88119C29.4342 2.88119 37.1188 10.5564 37.1188 20C37.1188 29.4436 29.4436 37.1188 20 37.1188Z"
                fill={circleColor || 'currentColor'}
            />
            <path d="M21.2606 16.2847H18.7021V31.5599H21.2606V16.2847Z" fill="currentColor" />
            <path
                d="M19.9807 9.26782C18.9837 9.26782 18.1748 10.0485 18.1748 11.1396C18.1748 12.2307 18.9837 12.9455 19.9807 12.9455C20.9778 12.9455 21.8525 12.1931 21.8525 11.1396C21.8525 10.0861 21.0154 9.26782 19.9807 9.26782Z"
                fill="currentColor"
            />
        </Icon>
    )
}

InfoIcon.propTypes = {circleColor: PropTypes.string}
export default InfoIcon
